module.exports = __webpack_public_path__ + "fonts/FormaDJRUI-Medium.e986a6cc.ttf";